// extracted by mini-css-extract-plugin
module.exports = {"overlay":"overlay_overlay__usMcX","fade":"overlay_fade___OMZ8"};